<script lang="ts">
  import { goto } from '$app/navigation';
  import { page } from '$app/stores';

  export let numRanked: number;
  export let numCustom: number;
  export let numJoinable: number;
  const pathToName: { [key: string]: string } = {
    '/lobbies': 'ranked',
    '/lobbies/customs': 'custom',
    '/lobbies/open': 'open'
  };
  $: activeTab = pathToName[$page.url.pathname];
  let selection = $page.url.pathname;
  const onChange = (url: string) => {
    goto(url);
  };
</script>

<div class="mb-2">
  <div class="sm:hidden">
    <label for="lobbyselect" class="sr-only">Select a tab</label>
    <select
      id="lobbyselect"
      name="lobbyselect"
      class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-black focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
      bind:value={selection}
      on:change={() => onChange(selection)}
    >
      <option selected={activeTab === 'ranked'} value="/lobbies">Ranked ({numRanked})</option>
      <option selected={activeTab === 'custom'} value="/lobbies/customs">
        Customs ({numCustom})
      </option>
      <option selected={activeTab === 'open'} value="/lobbies/open">
        Open Lobbies ({numJoinable})
      </option>
    </select>
  </div>
  <div class="hidden sm:block">
    <div class="border-b border-primary-dark">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700" -->
        <a
          href="/lobbies"
          class="flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium hover:border-primary hover:text-primary"
          class:text-primary={activeTab === 'ranked'}
          class:border-primary={activeTab === 'ranked'}
          class:border-transparent={activeTab !== 'ranked'}
        >
          Ranked
          <span
            class="ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
            class:bg-indigo-100={activeTab === 'ranked'}
            class:text-indigo-600={activeTab === 'ranked'}
            class:bg-gray-100={activeTab !== 'ranked'}
            class:text-gray-900={activeTab !== 'ranked'}
          >
            {numRanked}
          </span>
        </a>

        <a
          href="/lobbies/customs"
          class="flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium hover:border-primary hover:text-primary"
          class:text-primary={activeTab === 'custom'}
          class:border-primary={activeTab === 'custom'}
          class:border-transparent={activeTab !== 'custom'}
          aria-current="page"
        >
          Customs
          <span
            class="ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
            class:bg-indigo-100={activeTab === 'custom'}
            class:text-indigo-600={activeTab === 'custom'}
            class:bg-gray-100={activeTab !== 'custom'}
            class:text-gray-900={activeTab !== 'custom'}
          >
            {numCustom}
          </span>
        </a>

        <a
          href="/lobbies/open"
          class="flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium hover:border-primary hover:text-primary"
          class:text-primary={activeTab === 'open'}
          class:border-primary={activeTab === 'open'}
          class:border-transparent={activeTab !== 'open'}
          aria-current="page"
        >
          Open Lobbies
          <span
            class="ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
            class:bg-indigo-100={activeTab === 'open'}
            class:text-indigo-600={activeTab === 'open'}
            class:bg-gray-100={activeTab !== 'open'}
            class:text-gray-900={activeTab !== 'open'}
          >
            {numJoinable}
          </span>
        </a>
      </nav>
    </div>
  </div>
</div>
